var map = {
	"./dribbble.svg": 249,
	"./facebook.svg": 250,
	"./github.svg": 251,
	"./google.svg": 252,
	"./instagram.svg": 253,
	"./mailru.svg": 254,
	"./odnoklassniki.svg": 255,
	"./telegram.svg": 256,
	"./twitch.svg": 257,
	"./twitter.svg": 258,
	"./vkontakte.svg": 259,
	"./wordpress.svg": 260,
	"./yahoo.svg": 261,
	"./yandex.svg": 262
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 248;


//////////////////
// WEBPACK FOOTER
// ./src/img/socials ^\.\/.*\.svg$
// module id = 248
// module chunks = 0